import { useNavigate } from 'react-router-dom';
import { Button } from '@pinpoint/ui/button';
import { Play } from 'lucide-react';

const DemoCTA = () => {
    const navigate = useNavigate();

    const handleDemoClick = () => {
        navigate('/demo');
    };

    return (
        <section className="py-12 md:py-16">
            <div className="container mx-auto max-w-xl px-6 text-center">
                <div className="relative bg-primary/5 border border-primary/20 rounded-xl p-6 md:p-8">
                    <div className="relative">
                        <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
                            See the learning loop in action
                        </h2>
                        <p className="text-muted-foreground mb-5 text-base max-w-sm mx-auto leading-relaxed">
                            Explore how diagnosis, planning, and practice adapt as the system observes more student work.
                        </p>
                        <div className="flex justify-center">
                            <Button
                                size="default"
                                onClick={handleDemoClick}
                                className="text-sm px-6"
                            >
                                <Play className="w-4 h-4 mr-2" />
                                Launch Demo
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DemoCTA;
